<ion-avatar class="border" (click)="onAvatarClick($event)">
  <img *ngIf="avatarImageUrl && !isImageError; else initials"
       [src]="avatarImageUrl" alt="avatar"
       (error)="markImageAsBad()">

  <ng-template #initials>
    <img [src]="buildAvatarSvgDataUrl(fullName)" alt="avatar">
  </ng-template>
  <div *ngIf="typeAvatar === 'user-online'" class="point-indicator online"></div>
</ion-avatar>
